import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { PageCta } from './page-cta.model';

export const PAGE_CTAS_SCHEMA = Object.freeze({
  LAUNCH: null,
  ONBOARDING: null,
});
const RECORD = generateSchema(PAGE_CTAS_SCHEMA);
const KEYS: any = generateKeys(PAGE_CTAS_SCHEMA);

export class PageCtas extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.LAUNCH,
        value: props.get(KEYS.LAUNCH) ? new PageCta(this.launch) : null,
      },
      {
        key: KEYS.ONBOARDING,
        value: props.get(KEYS.ONBOARDING) ? new PageCta(this.onboarding) : null,
      },
    ]);

    return selfModel as PageCtas;
  }

  get launch(): PageCta {
    return this.get(KEYS.LAUNCH);
  }

  get onboarding(): PageCta {
    return this.get(KEYS.ONBOARDING);
  }
}
